/**
 * Store Deliveries Section — UI Layer (Clean Architecture).
 * Composes timeline table and transaction detail modal; uses useStoreDeliveries only.
 */

import React from 'react';
import {StoreDeliveryTimelineTable} from './StoreDeliveryTimelineTable';
import {StoreDeliveryTransactionDetailsModal} from './StoreDeliveryTransactionDetailsModal';
import {useStoreDeliveries} from '../../hooks/useStoreDeliveries';

interface StoreDeliveriesSectionProps {
  storeId: string;
  storeName: string;
}

export const StoreDeliveriesSection: React.FC<StoreDeliveriesSectionProps> = ({
  storeId,
  storeName
}) => {
  const {
    transactions,
    transactionsLoading,
    transactionsError,
    pagination,
    filters,
    setFilters,
    onPageChange,
    selectedTransactionId,
    selectedTransaction,
    transactionLoading,
    transactionError,
    viewTransaction,
    clearTransactionDetails
  } = useStoreDeliveries({storeId});

  const handleFiltersChange = (newFilters: typeof filters) => {
    setFilters({...newFilters, page: 1});
  };

  return (
    <div className="space-y-6">
      <StoreDeliveryTimelineTable
        transactions={transactions}
        loading={transactionsLoading}
        error={transactionsError}
        pagination={pagination}
        filters={filters}
        onFiltersChange={handleFiltersChange}
        onPageChange={onPageChange}
        onViewTransaction={viewTransaction}
      />

      {selectedTransactionId != null && (
        <StoreDeliveryTransactionDetailsModal
          isOpen
          onClose={clearTransactionDetails}
          transaction={selectedTransaction}
          loading={transactionLoading}
          error={transactionError}
        />
      )}
    </div>
  );
};
